export const EXSBDELIVERY_CREATE_RESET = 'EXSBDELIVERY_CREATE_RESET'
export const EXSBDELIVERY_CREATE_SET_CREATED = 'EXSBDELIVERY_CREATE_SET_CREATED'
export const EXSBDELIVERY_CREATE_SET_ERROR = 'EXSBDELIVERY_CREATE_SET_ERROR'
export const EXSBDELIVERY_CREATE_SET_VIOLATIONS = 'EXSBDELIVERY_CREATE_SET_VIOLATIONS'
export const EXSBDELIVERY_CREATE_TOGGLE_LOADING = 'EXSBDELIVERY_CREATE_TOGGLE_LOADING'
